import React, { useState, useEffect } from "react";

import moment from "moment";
import { toast } from "react-toastify";
import Table from "./Component.js";

const SelectContractTable = ({ tableId, bizApp, setBizApp, serviceAppList, appAuthTypeList, list, setList }) => {
    useEffect(() => {
        return () => {};
    }, [bizApp, serviceAppList, appAuthTypeList, list]);

    if(!bizApp || !serviceAppList || !appAuthTypeList) {
        return <></>;
    }
    
    const colSpanApp = serviceAppList.reduce((acc, a) => bizApp[a.key] ? (acc + (bizApp[a.key].fold ? 1 : 1 + bizApp[a.key].colAdd)) : acc, 0);
    return (
        <>
            <table className="table table-bordered table-contract table-contract-add" id={tableId || "contractInfoTable"}>
                <Table.Header.Add bizApp={bizApp} serviceAppList={serviceAppList} />
                <tbody>
                    {(!list || list.length === 0) && (
                        <tr className="table-contract-tr">
                            <td
                                style={{ backgroundColor: "#ffffff", padding: "10px" }}
                                colSpan={4 + colSpanApp}
                                className="table-contract-td"
                            >
                                위의 [반 추가] 버튼을 눌러 해당 연령의 계정을 추가해주세요.
                            </td>
                        </tr>
                    )}
                    {list.map((c, idx) => {
                        if (c.is555) return null;

                        const hasWaiting = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && c.app_auth[a.key].approval == "WT"&& !(c.app_auth[a.key].approval_org == "WT" || c.app_auth[a.key].approval_org == "AP")), false);
                        const hasApprovalOrg = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && (c.app_auth[a.key].approval_org == "WT" || c.app_auth[a.key].approval_org == "AP") == true), false);
                        const unionName = Table.func.getUnionName(serviceAppList, appAuthTypeList, c.app_auth);

                        return (
                            <tr className="table-contract-tr" style={{ borderTop: `1px solid #e6e6f2` }} key={`table-contract-tr-${idx}`}>
                                <td className="table-contract-td col-fixed" style={{}}>
                                    <Table.PopupClassHeader idx={idx} userId={c.user_id} list={list} setList={setList} />
                                </td>
                                <td className="table-contract-td col-fixed" style={{ textAligh: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {c.class_name}
                                </td>
                                <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {hasWaiting ? (
                                        <Table.QuantityInput auth={hasWaiting ? "AP" : "NA"} value={c.quantity} disabled={!hasWaiting} lock={!hasWaiting}
                                            quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(bizApp.tomonote.info, list, idx, val, callback)}
                                            quantityHandler={(val) => Table.func.quantityHandler(bizApp.tomonote.info, list, idx, val, setList)} />
                                    ) : (
                                        <>{c.quantity}</>
                                    )}
                                </td>
                                <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {hasWaiting ? (
                                        <Table.DeviceSelect approval={hasWaiting} approval_org={hasApprovalOrg} device={c.device} onSelectHandler={(val) => Table.func.deviceHandler(list, idx, val, setList)} />
                                    ) : (
                                        <>{!c.device ? '' : (c.device == 'tablet' ? '태블릿' : '전자칠판')}</>
                                    )}
                                </td>
                                <td className={`table-contract-td bg-union-70 ${'text-gray'}`} style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                                    {unionName || '결합 없음'}
                                </td>
                                {serviceAppList ? (
                                    serviceAppList.map((a) => {
                                        if(a.contractUseTas && bizApp[a.key]) {
                                            if(bizApp[a.key].hasPreContractedBranch) {
                                                return (
                                                    <>
                                                        {idx == 0 ? (
                                                            <td className="table-contract-td col-no-right" colSpan={bizApp[a.key].fold ? 1 : 1 + bizApp[a.key].colAdd} rowSpan={list.length}>
                                                                권한 없음
                                                            </td>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </>
                                                );
                                            } else {
                                                return (
                                                    <Table.CreateCell
                                                        bizApp={bizApp[a.key]}
                                                        fold={bizApp[a.key].fold}
                                                        age={c[a.age.field]}
                                                        quantity={c[a.quantity.field[0]]}
                                                        canChangeNoAuth={true}
                                                        auth={c.app_auth[a.key] ? c.app_auth[a.key].approval : "NA"}
                                                        auth_org={c.app_auth[a.key] ? c.app_auth[a.key].approval_org : "NA"}
                                                        authHandler={(auth) => {
                                                            const _list = list;
                                                            if (!_list[idx].app_auth[a.key]) {
                                                                _list[idx].app_auth[a.key] = {
                                                                    approval: "NA",
                                                                    authType: null,
                                                                    start_date: bizApp[a.key].start_date,
                                                                    end_date: bizApp[a.key].end_date,
                                                                };
                                                            } else if (_list[idx].app_auth[a.key].approval == "NA") {
                                                                _list[idx].app_auth[a.key].start_date = bizApp[a.key].start_date;
                                                                _list[idx].app_auth[a.key].end_date = bizApp[a.key].end_date;
                                                            }

                                                            if(auth) {
                                                                if(a.age.list.indexOf(c.defaultAge) < 0) {
                                                                    // 선택 가능한 연령 목록이 없는 경우 - 플라잉/젤링 2세반 -> 혼합반으로 설정
                                                                    _list[idx][a.age.field] = a.age.list[a.age.list.length - 1];
                                                                } else {
                                                                    _list[idx][a.age.field] = c.defaultAge;
                                                                }
                                                                _list[idx].app_auth[a.key].approval = "WT";
                                                            } else {
                                                                _list[idx][a.age.field] = c.defaultAge;
                                                                _list[idx].app_auth[a.key].approval = "NA";
                                                            }
            
                                                            setList(_list);
                                                            if (_list[idx].app_auth[a.key].approval != "NA") {
                                                                bizApp[a.key].onChangeBizAppFold(a.key, bizApp, false);
                                                            }
                                                        }}
                                                        quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(a, list, idx, val, callback)}
                                                        quantityHandler={(val) => Table.func.quantityHandler(a, list, idx, val, setList)}
                                                        disabled={c.app_auth[a.key] && (c.app_auth[a.key].approval_org == "AP" || c.app_auth[a.key].approval_org == "WT")}
                                                        is555={c.is555}
                                                    />
                                                );
                                            }}
                                        })
                                    ) : (
                                        <></>
                                    )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
};

const AddContractTable = ({ tableId, bizApp, setBizApp, serviceAppList, appAuthTypeList, list, setList }) => {
    useEffect(() => {
        return () => {};
    }, [bizApp, serviceAppList, list]);

    if(!bizApp || !serviceAppList) {
        return <></>;
    }
    
    return (
        <>
            <table className="table table-bordered table-contract table-contract-add" id={tableId || "contractInfoTable"}>
                <Table.Header.Add bizApp={bizApp} serviceAppList={serviceAppList} />
                <tbody>
                    {list.map((c, idx) => {
                        if (c.is555) return null;

                        const hasWaiting = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && c.app_auth[a.key].approval == "WT"&& !(c.app_auth[a.key].approval_org == "WT" || c.app_auth[a.key].approval_org == "AP")), false);                        
                        const hasApprovalOrg = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && (c.app_auth[a.key].approval_org == "WT" || c.app_auth[a.key].approval_org == "AP") == true), false);
                        const unionId = Table.func.getUnionId(serviceAppList, appAuthTypeList, c.app_auth);
                        return (
                            <tr className="table-contract-tr" style={{ borderTop: `1px solid #e6e6f2` }} key={`table-contract-tr-${idx}`}>
                                <td className="table-contract-td col-fixed" style={{}}>
                                    <Table.PopupClassHeader idx={idx} userId={c.user_id} list={list} setList={setList} />
                                </td>
                                <td className="table-contract-td col-fixed" style={{ textAligh: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {c.class_name}
                                </td>
                                <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {hasWaiting ? (
                                        <Table.QuantityInput auth={hasWaiting ? "AP" : "NA"} value={c.quantity} disabled={!hasWaiting} lock={!hasWaiting}
                                            quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(bizApp.tomonote.info, list, idx, val, callback)}
                                            quantityHandler={(val) => Table.func.quantityHandler(bizApp.tomonote.info, list, idx, val, setList)} />
                                    ) : (
                                        <>{c.quantity}</>
                                    )}
                                </td>
                                <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {hasWaiting ? (
                                        <Table.DeviceSelect approval={hasWaiting} approval_org={hasApprovalOrg} device={c.device} onSelectHandler={(val) => Table.func.deviceHandler(list, idx, val, setList)} />
                                    ) : (
                                        <>{!c.device ? '' : (c.device == 'tablet' ? '태블릿' : '전자칠판')}</>
                                    )}
                                </td>
                                <td className={`table-contract-td bg-union-70 ${'text-gray'}`} style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                                    <Table.UnionSelect classAuth={c.app_auth} union={unionId} appAuthTypeList={appAuthTypeList}
                                        disabled={!hasWaiting}
                                        onSelectHandler={(val) => Table.func.unionHandler(appAuthTypeList, list, idx, val, setList)} />
                                </td>
                                {serviceAppList ? (
                                    serviceAppList.map((a) => {
                                        if(a.contractUseTas && bizApp[a.key]) {
                                            if(bizApp[a.key].hasPreContractedBranch) {
                                                return (
                                                    <>
                                                        {idx == 0 ? (
                                                            <td className="table-contract-td col-no-right" colSpan={bizApp[a.key].fold ? 1 : 1 + bizApp[a.key].colAdd} rowSpan={list.length}>
                                                                권한 없음
                                                            </td>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </>
                                                );
                                            } else {
                                                return (
                                                    <Table.ConfirmCell
                                                        bizApp={bizApp[a.key]}
                                                        fold={bizApp[a.key].fold}
                                                        age={c[a.age.field]}
                                                        quantity={c[a.quantity.field[0]]}
                                                        canChangeNoAuth={true}
                                                        showChangeDuration={false}
                                                        auth={c.app_auth[a.key] ? c.app_auth[a.key].approval : "NA"}
                                                        auth_org={c.app_auth[a.key] ? c.app_auth[a.key].approval_org : "NA"}
                                                        authHandler={(auth) => {
                                                            const _list = [...list];
                                                            if (!_list[idx].app_auth[a.key]) {
                                                                _list[idx].app_auth[a.key] = {
                                                                    approval: "NA",
                                                                    authType: null,
                                                                    start_date: bizApp[a.key].start_date,
                                                                    end_date: bizApp[a.key].end_date,
                                                                };
                                                            } else if (_list[idx].app_auth[a.key].approval == "NA") {
                                                                _list[idx].app_auth[a.key].start_date = bizApp[a.key].start_date;
                                                                _list[idx].app_auth[a.key].end_date = bizApp[a.key].end_date;
                                                            }
            
                                                            if (_list[idx].id > 0 && _list[idx].app_auth[a.key].approval === "AP") {
                                                                if (auth.age === -1) {
                                                                    alert("승인된 계정의 미사용 처리는 불가능합니다.");
                                                                } else {
                                                                    _list[idx].age = auth.age;
                                                                }
                                                            } else {
                                                                if (auth.age === -1) {
                                                                    const [checkUnionOk, unbindUnionResult] = Table.func.checkUnionUnbind(a.key, list, idx);
                                                                    if(checkUnionOk || unbindUnionResult) {
                                                                        _list[idx].app_auth[a.key].approval = "NA";
                                                                        if(unbindUnionResult) {
                                                                            Table.func.unionHandler(appAuthTypeList, _list, idx, null, setList);
                                                                        }
                                                                    } else {
                                                                        return;
                                                                    }
                                                                } else {
                                                                    _list[idx].app_auth[a.key].approval = "WT";
                                                                    _list[idx][a.age.field] = auth.age;
                                                                }
                                                            }
            
                                                            setList(_list);
                                                            if (_list[idx].app_auth[a.key].approval != "NA") {
                                                                bizApp[a.key].onChangeBizAppFold(a.key, bizApp, false);
                                                            }
                                                        }}
                                                        quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(a, list, idx, val, callback)}
                                                        quantityHandler={(val) => Table.func.quantityHandler(a, list, idx, val, setList)}
                                                        disabled={!(c.app_auth[a.key] && c.app_auth[a.key].approval == "WT" && c.app_auth[a.key].approval_org != "WT")}
                                                        is555={c.is555}
                                                    />
                                                );
                                            }}
                                        })
                                    ) : (
                                        <></>
                                    )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
};

const AddConfirmContractTable = ({ tableId, bizApp, setBizApp, serviceAppList, appAuthTypeList, list, setList }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    useEffect(() => {
        if(!startDate && !endDate) {
            const today = moment();
            const endDate = moment().add(1, "year");
            if (today.get("month") >= 5) {
                endDate.add(1, "year");
            }
            setStartDate(today.format("YYYY-MM-01"));
            setEndDate(endDate.format("YYYY-02-01"));
        }
        return () => {};
    }, [bizApp, serviceAppList, list]);
    
    const colSpanApp = serviceAppList.reduce((acc, a) => bizApp[a.key] ? (acc + (bizApp[a.key].fold ? 1 : 1 + bizApp[a.key].colAdd)) : acc, 0);

    return (
        <>
            <table className="table table-bordered table-contract table-contract-add-confirm" id={tableId || "contractInfoTable"}>
                <Table.Header.Add bizApp={bizApp} serviceAppList={serviceAppList} />
                <tbody>
                    {list.map((c, idx) => {
                        if (c.is555) return null;

                        const hasWaiting = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && c.app_auth[a.key].approval == "WT"&& !(c.app_auth[a.key].approval_org == "WT" || c.app_auth[a.key].approval_org == "AP")), false);
                        const unionId = Table.func.getUnionId(serviceAppList, appAuthTypeList, c.app_auth);
                        return (
                            <tr className="table-contract-tr" key={`table-add-confirm-contract-tr-${idx}`}>
                                <td className="table-contract-td col-fixed">{c.user_id || "-"}</td>
                                <td className="table-contract-td col-fixed" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {c.class_name}
                                </td>
                                <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {c.quantity}
                                </td>
                                <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {!c.device ? '' : (c.device == 'tablet' ? '태블릿' : '전자칠판')}
                                </td>
                                <td className={`table-contract-td bg-union-70 ${'text-gray'}`} style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                                    <Table.UnionSelect classAuth={c.app_auth} union={unionId} appAuthTypeList={appAuthTypeList}
                                        disabled={!hasWaiting && c.unionId_org}
                                        onSelectHandler={(val) => Table.func.unionHandler(appAuthTypeList, list, idx, val, setList)} />
                                </td>
                                {serviceAppList ? (
                                    serviceAppList.map((a) => {
                                        if(a.contractUseTas && bizApp[a.key]) {
                                            if(bizApp[a.key].hasPreContractedBranch) {
                                                return (
                                                    <>
                                                        {idx == 0 ? (
                                                            <td className="table-contract-td col-no-right" colSpan={bizApp[a.key].fold ? 1 : 1 + bizApp[a.key].colAdd} rowSpan={list.length}>
                                                                권한 없음
                                                            </td>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </>
                                                );
                                            } else {
                                                return (
                                                    <Table.ConfirmCell
                                                        bizApp={bizApp[a.key]}
                                                        fold={bizApp[a.key].fold}
                                                        age={c[a.age.field]}
                                                        quantity={c[a.quantity.field[0]]}
                                                        canChangeNoAuth={true}
                                                        showChangeDuration={false}
                                                        auth={c.app_auth[a.key] ? c.app_auth[a.key].approval : "NA"}
                                                        auth_org={c.app_auth[a.key] ? c.app_auth[a.key].approval_org : "NA"}
                                                        authHandler={(auth) => {
                                                            const _list = [...list];
                                                            if (!_list[idx].app_auth[a.key]) {
                                                                _list[idx].app_auth[a.key] = {
                                                                    approval: "NA",
                                                                    authType: null,
                                                                    start_date: bizApp[a.key].start_date,
                                                                    end_date: bizApp[a.key].end_date,
                                                                };
                                                            } else if (_list[idx].app_auth[a.key].approval == "NA") {
                                                                _list[idx].app_auth[a.key].start_date = bizApp[a.key].start_date;
                                                                _list[idx].app_auth[a.key].end_date = bizApp[a.key].end_date;
                                                            }
            
                                                            if (_list[idx].id > 0 && _list[idx].app_auth[a.key].approval === "AP") {
                                                                if (auth.age === -1) {
                                                                    alert("승인된 계정의 미사용 처리는 불가능합니다.");
                                                                } else {
                                                                    _list[idx].age = auth.age;
                                                                }
                                                            } else {
                                                                if (auth.age === -1) {
                                                                    const [checkUnionOk, unbindUnionResult] = Table.func.checkUnionUnbind(a.key, list, idx);
                                                                    if(checkUnionOk || unbindUnionResult) {
                                                                        _list[idx].app_auth[a.key].approval = "NA";
                                                                        if(unbindUnionResult) {
                                                                            Table.func.unionHandler(appAuthTypeList, _list, idx, null, setList);
                                                                        }
                                                                    } else {
                                                                        return;
                                                                    }
                                                                } else {
                                                                    _list[idx].app_auth[a.key].approval = "WT";
                                                                    _list[idx][a.age.field] = auth.age;
                                                                }
                                                            }
            
                                                            setList(_list);
                                                            if (_list[idx].app_auth[a.key].approval != "NA") {
                                                                bizApp[a.key].onChangeBizAppFold(a.key, bizApp, false);
                                                            }
                                                        }}
                                                        quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(a, list, idx, val, callback)}
                                                        quantityHandler={(val) => Table.func.quantityHandler(a, list, idx, val, setList)}
                                                        disabled={!(c.app_auth[a.key] && c.app_auth[a.key].approval == "WT" && c.app_auth[a.key].approval_org != "WT")}
                                                        is555={c.is555}
                                                    />
                                                );
                                            }}
                                        })
                                    ) : (
                                        <></>
                                    )}
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr className="table-contract-tr table-contract-tr-summary">
                        <td colSpan="2" className="bg-dark text-light text-center font-bold table-contract-td col-fixed">
                            기존 건 합계
                        </td>
                        <td colSpan="2" className="bg-dark text-light text-center font-bold table-contract-td col-fixed">
                        </td>
                        <td style={{ backgroundColor: "#f9f9ff" }}></td>
                        {serviceAppList ? (
                            serviceAppList.map((a) => {
                                if(a.contractUseTas && bizApp[a.key]) {
                                    if(bizApp[a.key].hasPreContractedBranch) {
                                        return (
                                            <td className="table-contract-td col-no-right" colSpan={bizApp[a.key].fold ? 1 : 1 + bizApp[a.key].colAdd} rowSpan={2}></td>
                                        );
                                    } else {
                                        return (
                                            <td style={{ backgroundColor: "#f9f9ff" }} colSpan={bizApp[a.key].fold ? 1 : 1 + bizApp[a.key].colAdd}>{bizApp[a.key].count_org}개</td>
                                        );
                                    }
                                }})
                            ) : (
                                <></>
                            )}
                    </tr>
                    <tr className="table-contract-tr table-contract-tr-summary">
                        <td colSpan="2" className="bg-dark text-light text-center font-bold table-contract-td col-fixed">
                            추가 건 합계
                        </td>
                        <td colSpan="2" className="bg-dark text-light text-center font-bold table-contract-td col-fixed">
                        </td>
                        <td style={{ backgroundColor: "#f9f9ff" }}></td>
                        {serviceAppList ? (
                            serviceAppList.map((a) => {
                                if(a.contractUseTas && bizApp[a.key]) {
                                    if(bizApp[a.key].hasPreContractedBranch) {
                                        return (
                                            <></>
                                        );
                                    } else {
                                        return (
                                            <td style={{ backgroundColor: "#f9f9ff" }} colSpan={bizApp[a.key].fold ? 1 : 1 + bizApp[a.key].colAdd}>{bizApp[a.key].count}개</td>
                                        );
                                    }
                                }})
                            ) : (
                                <></>
                            )}
                    </tr>
                    <tr className="table-contract-tr table-contract-tr-period">
                        <td colSpan="2" className="bg-dark text-light text-center font-bold table-contract-td col-fixed">
                            계약 기간(추가 건)
                        </td>
                        <td colSpan="2" className="bg-dark text-light text-center font-bold table-contract-td col-fixed">
                        </td>
                        <td
                            className="p-0"
                            style={{ backgroundColor: "#f9f9ff" }}
                            colSpan={colSpanApp + 1}                            
                        >
                            <Table.DateCell
                                startDate={new Date(startDate)}
                                endDate={new Date(endDate)}
                                yearFormat="yyyy"
                                width="300px"
                                endDateHandler={(date) => {
                                    const _bizApp = { ...bizApp };
                                    const _list = [...list];
                                    const newEndDate = moment(date).format("YYYY-02-01");
                                    _list.forEach((c) => {
                                        Object.keys(c.app_auth).forEach((a) => {
                                            if (c.app_auth[a] && (c.app_auth[a].approval_org == undefined || c.app_auth[a].approval_org == "NA") && (c.app_auth[a].approval == "AP" || c.app_auth[a].approval == "WT")) {                                                    
                                                if (_bizApp[a].end_date == c.app_auth[a].end_date) {
                                                    c.app_auth[a].end_date = newEndDate;
                                                }
                                            }
                                        });
                                    });
                                    setList(_list);
                                    Object.keys(_bizApp).forEach((app) => {
                                        _bizApp[app].end_date =newEndDate;
                                    });
                                    setBizApp(_bizApp);
                                    setEndDate(newEndDate);
                                }}
                            />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </>
    );
};

export default {
    SelectTable: SelectContractTable,
    AddTable: AddContractTable,
    AddConfirmTable: AddConfirmContractTable,
};
